import { render, staticRenderFns } from "./ArchiveUnitDialog.vue?vue&type=template&id=3eb27cb9&scoped=true&"
import script from "./ArchiveUnitDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveUnitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb27cb9",
  null
  
)

export default component.exports